import React, {Fragment} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import FeatureDescription from "../../visComponents/featureDescription";

const FeatureInfoDescription = (props) => {

  const {fabricatorData, intl, selectionFeatureInfo, feature, brief} = props;
  const activeFeature = feature || selectionFeatureInfo;

  let pros = [];
  let subDescription = activeFeature.dbFeature.subDescription;
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.messages) {
    if (intl.locale === "fr-FR" && intl.messages["transDoc.subDescription_FR." + activeFeature.dbFeature.sharedFeatureName]) {
      subDescription = intl.formatMessage({id: "transDoc.subDescription_FR." + activeFeature.dbFeature.sharedFeatureName})
    } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customSubDescription_PL." + activeFeature.dbFeature.sharedFeatureName]) {
      subDescription = intl.formatMessage({id: "transDoc.customSubDescription_PL." + activeFeature.dbFeature.sharedFeatureName})
    }
  }
  if (!brief && subDescription && subDescription.length > 0) {
    pros = subDescription.split('\n').filter(n => n);
  }

  return (
    <Fragment>
      <FeatureDescription className="product-info__description" feature={activeFeature} brief={brief}/>
      {pros.length ? (
        <ul className="product-info__pros">
          {pros.map((pros, index) => {
            return <li className="product-info__pros-item" key={"pros" + index}>{pros}</li>
          })}
        </ul>
      ) : null}
    </Fragment>
  );
};

FeatureInfoDescription.propTypes = {
  feature: PropTypes.object,
  brief: PropTypes.bool,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureInfoDescription)
)
